import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    path: String,
    method: String,
    deleteButtonText: String,
    cancelButtonText: String,
    title: String,
    message: String
  };

  static classes = ["container"];

  show() {
    const dialog = $(
      `<div id='dialog-confirm' role='alert'><p>${this.messageValue}</p></div>`
    );
  
    if (!$("#dialog-confirm").length) $("body").append(dialog);

    $('.reveal-modal-bg').css('z-index', 100);

    dialog.dialog({
      dialogClass: this.containerClass,
      resizable: false,
      draggable: false,
      modal: true,
      title: this.titleValue,

      buttons: {
        Cancel: {
          text: this.cancelButtonTextValue,
          click: function () {
            $(this).dialog("close");
          },
        },
        Delete: {
          text: this.deleteButtonTextValue,
          click: function () {
            $(this).dialog("close");
            window.modal.dirty = false;
          },
          "data-url": this.pathValue,
          "data-method": this.methodValue,
          "data-remote": "true",
        },
      }
    });
  }
}
